import { useCallback } from "react"
import { useCompanyApi } from "../../../../hooks/useCompanyApi"
import { patchAnalysis } from "../../../../lib/api"
import { AttendeesCardView } from "./AttendeesCardView"
import type { IProps } from "./interfaces"

/**
 * AttendeesCard — smart wrapper. Owns the company API client and the
 * owner-name save handler (patchAnalysis + edit-log refresh); AttendeesCardView
 * renders every contributor from props. Split so the view is Storybookable in
 * isolation, with no `useCompanyApi` in the render path.
 */
export function AttendeesCard(props: IProps): React.JSX.Element {
  const company = useCompanyApi()
  const { editContext } = props

  const onOwnerSave = useCallback(
    async (fieldPath: string, value: string): Promise<void> => {
      if (!company || !editContext) throw new Error("company unavailable")
      await patchAnalysis(company, editContext.meetingId, fieldPath, value)
      editContext.onEdited()
    },
    [company, editContext],
  )

  return <AttendeesCardView {...props} onOwnerSave={onOwnerSave} />
}
